// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__oLauu","body":"style_body__bfoNa"};